// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__2gsbu","modal":"Modal_modal__2fhE1","header":"Modal_header__NFWLk","body":"Modal_body__flHOg","footer":"Modal_footer__XOatt","close":"Modal_close__XXaaC"};